import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const ProjectForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    project_title: "",
    start_date: "",
    end_date: "",
    description: "",
    estimate_cost: "",
    status: "",
    assign_to: "",
    mobile_no: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.project_title.trim()) {
      newErrors.project_title = "प्रकल्प शीर्षक आवश्यक आहे (Project title is required)";
    }
    if (!formData.start_date) {
      newErrors.start_date = "सुरू दिनांक आवश्यक आहे (Start date is required)";
    }
    if (!formData.status) {
      newErrors.status = "प्रकल्प स्थिती निवडा (Status is required)";
    }
    if (!formData.assign_to.trim()) {
      newErrors.assign_to = "सोपविलेली व्यक्ती आवश्यक आहे (Assignee name is required)";
    }
    if (!formData.mobile_no.trim()) {
      newErrors.mobile_no = "मोबाईल क्रमांक आवश्यक आहे (Mobile number is required)";
    } else if (!/^\d{10}$/.test(formData.mobile_no)) {
      newErrors.mobile_no = "मोबाईल क्रमांक १० अंकी असावा (Mobile number must be 10 digits)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      const response = await apiFetch("leader_admin/add_work", {
        method: "POST",
        body: JSON.stringify(formData),
      });

      if (response) {
        alert("प्रकल्प माहिती यशस्वीरित्या जतन केली गेली.");
        navigate("/projects");
      }

    } catch (error) {
      console.error(error);
      alert("सर्व्हर त्रुटी आली.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                📋 नवीन प्रकल्प जोडा (Add New Project / Work)
              </h4>
              <small className="text-white-50">प्रकल्प संबंधित माहिती भरण्यासाठी फॉर्म</small>
            </div>
          </div>

          <Link to="/projects" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            प्रकल्पांची यादी (Project List)
          </Link>
        </div>

        <div className="card shadow-lg border-0 rounded-4">
          <div className="card-body">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                {/* Project Title */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    प्रकल्प शीर्षक <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="project_title"
                    className={`form-control ${errors.project_title ? "is-invalid" : ""}`}
                    value={formData.project_title}
                    onChange={handleChange}
                  />
                  {errors.project_title && (
                    <small className="text-danger d-block mt-1">{errors.project_title}</small>
                  )}
                </div>

                {/* Start Date */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    प्रकल्प सुरू दिनांक <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    name="start_date"
                    className={`form-control ${errors.start_date ? "is-invalid" : ""}`}
                    value={formData.start_date}
                    onChange={handleChange}
                  />
                  {errors.start_date && (
                    <small className="text-danger d-block mt-1">{errors.start_date}</small>
                  )}
                </div>

                {/* End Date */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    प्रकल्प समाप्त दिनांक
                  </label>
                  <input
                    type="date"
                    name="end_date"
                    className="form-control"
                    value={formData.end_date}
                    onChange={handleChange}
                  />
                </div>

                {/* Description */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    प्रकल्प वर्णन
                  </label>
                  <input
                    type="text"
                    name="description"
                    className="form-control"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>

                {/* Estimate Cost */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    अंदाजे खर्च
                  </label>
                  <input
                    type="number"
                    name="estimate_cost"
                    className="form-control"
                    value={formData.estimate_cost}
                    onChange={handleChange}
                  />
                </div>

                {/* Status */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    प्रकल्प स्थिती <span className="text-danger">*</span>
                  </label>
                  <select
                    name="status"
                    className={`form-select ${errors.status ? "is-invalid" : ""}`}
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="">निवडा</option>
                    <option value="complete">पूर्ण</option>
                    <option value="ongoing">प्रगतीमध्ये</option>
                    <option value="pending">प्रलंबित</option>
                  </select>
                  {errors.status && (
                    <small className="text-danger d-block mt-1">{errors.status}</small>
                  )}
                </div>

                {/* Assign To */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    सोपविले <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="assign_to"
                    className={`form-control ${errors.assign_to ? "is-invalid" : ""}`}
                    value={formData.assign_to}
                    onChange={handleChange}
                  />
                  {errors.assign_to && (
                    <small className="text-danger d-block mt-1">{errors.assign_to}</small>
                  )}
                </div>

                {/* Mobile */}
                <div className="col-md-4">
                  <label className="form-label fw-semibold" style={{ fontSize: "0.85rem" }}>
                    मोबाईल क्रमांक <span className="text-danger">*</span>
                  </label>
                  <input
                    type="tel"
                    name="mobile_no"
                    className={`form-control ${errors.mobile_no ? "is-invalid" : ""}`}
                    value={formData.mobile_no}
                    onChange={handleChange}
                    maxLength="10"
                  />
                  {errors.mobile_no && (
                    <small className="text-danger d-block mt-1">{errors.mobile_no}</small>
                  )}
                </div>
              </div>

              {/* Submit */}
              <div className="mt-4 text-end">
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                  style={{ fontSize: "0.85rem" }}
                >
                  {loading ? "जतन होत आहे..." : "जतन करा"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ProjectForm;